import { useEffect, useState } from "react";
import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import CloseIcon from "@mui/icons-material/Close";

// Full-screen warning shown once per player when a red-flagged player is loaded.
// Pass `user` only while the parent screen is open; it re-arms when user goes null.
export default function RedFlagPopup({ user, disabled = false }) {
  const [dismissedId, setDismissedId] = useState(null);
  const id = user?._id ? String(user._id) : null;

  useEffect(() => { if (!id) setDismissedId(null); }, [id]);

  const open = !disabled && !!user?.red_flag && !!id && dismissedId !== id;
  const close = () => setDismissedId(id);

  return (
    <Dialog
      open={open}
      fullScreen
      onClose={(_, reason) => { if (reason !== "backdropClick" && reason !== "escapeKeyDown") close(); }}
      sx={{ zIndex: 2000 }}
      PaperProps={{ sx: { background: "linear-gradient(135deg,#7f0000,#b71c1c 55%,#d32f2f)", color: "#fff" } }}
    >
      <IconButton onClick={close} sx={{ position: "absolute", top: 16, right: 16, color: "#fff" }} aria-label="Close">
        <CloseIcon fontSize="large" />
      </IconButton>

      <Box
        display="flex" flexDirection="column" alignItems="center" justifyContent="center"
        textAlign="center" minHeight="100%" px={3} py={6} gap={3}
      >
        <FlagIcon sx={{ fontSize: { xs: 90, md: 130 } }} />
        <Typography variant="h2" fontWeight={900} letterSpacing={4} sx={{ fontSize: { xs: 40, md: 64 } }}>
          RED FLAG
        </Typography>

        <Box>
          <Typography variant="h5" fontWeight={700}>{user?.name || "Player"}</Typography>
          <Typography variant="body1" sx={{ opacity: 0.85 }}>
            {[user?.playerId && `ID: ${user.playerId}`, user?.phone && `📱 ${user.phone}`].filter(Boolean).join("  |  ")}
          </Typography>
        </Box>

        <Box sx={{ background: "rgba(0,0,0,0.25)", border: "2px solid rgba(255,255,255,0.5)", borderRadius: 3, px: 4, py: 3, maxWidth: 720, width: "100%" }}>
          <Typography variant="overline" sx={{ opacity: 0.8, letterSpacing: 2 }}>Remark</Typography>
          <Typography variant="h5" fontWeight={600} sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            ⚠️ {user?.red_flag_remark || "This player has been flagged."}
          </Typography>
        </Box>

        <Typography variant="body1" sx={{ opacity: 0.9 }}>Proceed with caution.</Typography>

        <Button
          variant="contained" size="large" onClick={close} autoFocus
          sx={{ mt: 1, px: 6, py: 1.5, fontWeight: 700, fontSize: 18, background: "#fff", color: "#b71c1c", "&:hover": { background: "#ffebee" } }}
        >
          I Understand — Close
        </Button>
      </Box>
    </Dialog>
  );
}
